import { render, staticRenderFns } from "./VerFaltante.vue?vue&type=template&id=6dd0f27a&scoped=true"
import script from "./VerFaltante.vue?vue&type=script&lang=js"
export * from "./VerFaltante.vue?vue&type=script&lang=js"
import style0 from "./VerFaltante.vue?vue&type=style&index=0&id=6dd0f27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0f27a",
  null
  
)

export default component.exports